import { Pipe, PipeTransform } from '@angular/core';
import { toDisplayDate, toDisplayDateTime, toDisplayMonthYear } from '../CommonFunctions/date-utils';

/**
 * UI date formatter. Defaults to 'MMM-DD-YYYY' (May-10-1990), matching every
 * datepicker's dateInputFormat. Pass 'MMM YYYY' for month-only values, or
 * 'MMM-DD-YYYY h:mm a' for an instant (a login time), which is the only case
 * that is converted to the viewer's timezone.
 *
 * This pipe is for DISPLAY ONLY. Use `toApiDate` (or `toLegacyUsDate` where an
 * endpoint still expects MM-DD-YYYY) when building a request payload.
 */
@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  transform(value: any, format: 'MMM-DD-YYYY' | 'MMM YYYY' | 'MMM-DD-YYYY h:mm a' = 'MMM-DD-YYYY'): string {
    let formatted: string;
    if (format === 'MMM YYYY') {
      formatted = toDisplayMonthYear(value);
    } else if (format === 'MMM-DD-YYYY h:mm a') {
      formatted = toDisplayDateTime(value);
    } else {
      formatted = toDisplayDate(value);
    }
    return formatted || value; // If the date is invalid, return the original value
  }

}
